"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hbimmunMessages = exports.hbsAgMessages = exports.antiHbsMessages = exports.ahbctotalMessages = exports.Hbimmun = exports.HbsAg = exports.AntiHbs = exports.AHbctotal = void 0;
const schema_1 = require("../../../../schema");
var AHbctotal;
(function (AHbctotal) {
    AHbctotal["POSITIVE"] = "POSITIVE";
    AHbctotal["NEGATIVE"] = "NEGATIVE";
})(AHbctotal || (exports.AHbctotal = AHbctotal = {}));
var AntiHbs;
(function (AntiHbs) {
    AntiHbs["POSITIVE"] = "POSITIVE";
    AntiHbs["NEGATIVE"] = "NEGATIVE";
})(AntiHbs || (exports.AntiHbs = AntiHbs = {}));
var HbsAg;
(function (HbsAg) {
    HbsAg["POSITIVE"] = "POSITIVE";
    HbsAg["NEGATIVE"] = "NEGATIVE";
})(HbsAg || (exports.HbsAg = HbsAg = {}));
var Hbimmun;
(function (Hbimmun) {
    Hbimmun["YES"] = "YES";
    Hbimmun["NO"] = "NO";
})(Hbimmun || (exports.Hbimmun = Hbimmun = {}));
exports.ahbctotalMessages = {
    [AHbctotal.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.ahbctotal.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [AHbctotal.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.ahbctotal.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
exports.antiHbsMessages = {
    [AntiHbs.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.antiHbs.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [AntiHbs.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.antiHbs.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
exports.hbsAgMessages = {
    [HbsAg.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.hbsAg.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HbsAg.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.hbsAg.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
exports.hbimmunMessages = {
    [Hbimmun.YES]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.hbimmun.YES",
        defaultMessage: "Igen"
    },
    [Hbimmun.NO]: {
        id: "ktx.basicRegistrationData.viralSerology.hbvStatus.hbimmun.NO",
        defaultMessage: "Nem"
    }
};
const aHbctotal = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AHbctotal.POSITIVE),
    schema_1.Schema.singleChoiceItem(AHbctotal.NEGATIVE)
]).optional();
const antiHbs = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AntiHbs.POSITIVE),
    schema_1.Schema.singleChoiceItem(AntiHbs.NEGATIVE)
]);
const antiHbsValue = schema_1.Schema.number().unit("mU/ml").integer().min(0).max(9999);
const hbsAg = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbsAg.POSITIVE),
    schema_1.Schema.singleChoiceItem(HbsAg.NEGATIVE)
]);
const hbimmun = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Hbimmun.YES),
    schema_1.Schema.singleChoiceItem(Hbimmun.NO)
]);
exports.validator = schema_1.Schema.object()
    .expiration(31536000)
    .default({})
    .sealed(true)
    .properties({
    aHBctotal: aHbctotal,
    antiHBs: antiHbs,
    antiHBsValue: antiHbsValue,
    HBsAg: hbsAg,
    HBImmun: hbimmun
})
    .interpretation({ vocab: "ktx", code: "microbiological_hbv_status" })
    .tag({ vocab: "snomed", code: "62889000", source: "synonym" })
    .tag({ vocab: "ktx", code: "microbiological_procedure" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "165994006" });
